import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import "../style.css";
import CommonForm from "../../../../../components/commonform/commonForm";
import Snackbar from "../../../../../components/snackbar/snackbar";
export default function View(props) {
  const [agreeDeclaration1, setAgreeDeclaration1] = useState(false);
  const [agreeDeclaration2, setAgreeDeclaration2] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const handleEdit = () => { };
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const handleCheckChangeDeclaration1 = (e) => {
    let checked = e.target.checked;
    setAgreeDeclaration1(checked);
  };
  const handleCheckChangeDeclaration2 = (e) => {
    let checked = e.target.checked;
    setAgreeDeclaration2(checked);
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.logout();
    }
  };
  const handleCheckDeclaration = () => {
    if (!agreeDeclaration1 || !agreeDeclaration2) {
      setSnackMessage("Please agree to both declarations before submitting.");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }
    props.action(3);
  };

  return (
    <div className="bg-white p-4 rounded">
      <div className="demox">
        <div className="conti view-containe">
          <h6>
            <b>Company Details</b>
          </h6>

          <hr />

          <div className="data">
            <div className="row">
              <div className="col-3">Company Name (as per registration/CIN)</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.company_name ?? ""}</div>
            </div>
            <div className="row">
              <div className="col-3">Contact Person Name</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.person_name ?? ""}</div>
            </div>
            <div className="row">
              <div className="col-3">Designation</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.person_designation}</div>
            </div>
            <div className="row">
              <div className="col-3">Registration/CIN Number</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.cin_number}</div>
            </div>
            {props.basicData.registration_certificate_name && (
              <div className="row">
                <div className="col-3">Registration Certificate</div>
                <div className="col-1">:</div>
                <div className="col-7">{props.basicData.registration_certificate_name}</div>
              </div>
            )}
            <div className="row">
              <div className="col-3">Corporate/Registered Address</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.address ?? ""}</div>
            </div>
            <div className="row">
              <div className="col-3">Email Id (Primary Contact)</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.email ?? ""}</div>
            </div>
            <div className="row">
              <div className="col-3">Contact No (Primary Contact)</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.mobile_number ?? ""}</div>
            </div>
            <div className="row">
              <div className="col-3">Alternate Phone</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {props.basicData.alternate_phone && (
                  <>
                    {props.basicData.country_code &&
                      props.basicData.country_code !== "" &&
                      props.basicData.country_code !== "undefined" &&
                      props.basicData.country_code !== "null" && (
                        <>
                          {props.basicData.country_code ?? ""}{" "}
                          {props.basicData.country_code &&
                            props.basicData.country_code !== ""
                            ? "-"
                            : ""}{" "}
                        </>
                      )}
                  </>
                )}
                {props.basicData.alternate_phone ?? ""}
              </div>
            </div>
            <div className="row">
              <div className="col-3">Alternate Email</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.alternate_email ?? ""}</div>
            </div>
            <div className="row">
              <div className="col-3">Website Link</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.site_link ?? ""}</div>
            </div>
            {props.basicData.logo_name && (
              <div className="row">
                <div className="col-3">Upload Company Logo</div>
                <div className="col-1">:</div>
                <div className="col-7">{props.basicData.logo_name ?? ""}</div>
              </div>
            )}
            {/* Company Profile */}
            <div className="row mt-3">
              <div className="col-12">
                <b>Company Profile</b>
              </div>
            </div>
            <div className="row">
              <div className="col-3">Abstract Company Profile</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {props.basicData.abstract_project_proposal ?? ""}
              </div>
            </div>
            <div className="row">
              <div className="col-3">Product Profiles</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {props.basicData?.product_profiles?.map((item) => (
                  <>
                    <div className="col-12 mb-1">
                      <b>{item.product_name ?? ""}</b>
                    </div>
                    <div className="col-12 mb-3 ">
                      <div>{ReactHtmlParser(item.product_desc)}</div>
                    </div>
                  </>
                ))}
              </div>
            </div>
            {/* Business Domains */}
            <div className="row mt-3">
              <div className="col-12">
                <b>Domain of Activity</b>
              </div>
            </div>
            <div className="row">
              <div className="col-3">Domains</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {props.basicData?.domain_types && (
                  <>
                    {props.basicData?.domain_types?.map((dom, i) => (
                      <div>{dom.domain_name} </div>
                    ))}
                  </>
                )}
                {/* {(props.basicData?.any_other_flag === "1" ||
                props.basicData?.any_other_flag) && (
                <>{props.basicData?.any_other_domain}</>
              )} */}
                {(props.basicData?.any_other_flag === "1" ||
                  props.basicData?.any_other_flag) && (
                    <div>{props.basicData?.any_other_domain}</div>
                  )}
              </div>
            </div>
            {/* Financial & Investment Details */}
            {/* <div className="row mt-3">
              <div className="col-12">
                <b>Financial & Investment Details</b>
              </div>
            </div> */}
            {/* <div className="row">
              <div className="col-3">Capital Investment (in Crores)</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.capital_investment ?? ""}</div>
            </div> */}
            {/* Financial Records Section */}
            {props.basicData.financial_records &&
              props.basicData.financial_records.length > 0 && (
                <>
                  <div className="row mt-3">
                    <div className="col-12">
                      <b>Financial Records</b>
                    </div>
                  </div>
                  <hr />
                  {props.basicData.financial_records.map((record, idx) => (
                    <div key={idx} className="mb-4 p-3 border rounded bg-light">
                      <div className="row">
                        <div className="col-3"><b>Financial Year</b></div>
                        <div className="col-1">:</div>
                        <div className="col-7"><b>{record.financial_year ?? ""}</b></div>
                      </div>
                      <div className="row">
                        <div className="col-3">Turnover (in Crores)</div>
                        <div className="col-1">:</div>
                        <div className="col-7">{record.fy_turnover ?? ""}</div>
                      </div>
                      <div className="row">
                        <div className="col-3">Capital Investment (in Crores)</div>
                        <div className="col-1">:</div>
                        <div className="col-7">{record.capital_investment ?? ""}</div>
                      </div>
                      
                      {record.remarks && (
                        <div className="row mt-2">
                          <div className="col-3">Remarks</div>
                          <div className="col-1">:</div>
                          <div className="col-7">{record.remarks}</div>
                        </div>
                      )}
                    </div>
                  ))}
                </>
              )}
            <div className="row">
              <div className="col-3">Foreign Exchange (FE) Component (if any)</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.fe_component ?? ""}</div>
            </div>
            {/* Employment Details */}
            <div className="row mt-3">
              <div className="col-12">
                <b>Employment Details</b>
              </div>
            </div>
            {props.basicData.financial_records &&
              props.basicData.financial_records.length > 0 && (
                <>
                  {props.basicData.financial_records.map((record, idx) => (
                    <div key={`employment-${idx}`} className="mt-2">
                      <div className="row">
                        <div className="col-12">
                          <b>Employment Split up - {record.financial_year}</b>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-3">Male</div>
                        <div className="col-1">:</div>
                        <div className="col-7">{record.dir_employ_male ?? "0"}</div>
                      </div>
                      <div className="row">
                        <div className="col-3">Female</div>
                        <div className="col-1">:</div>
                        <div className="col-7">{record.dir_employ_female ?? "0"}</div>
                      </div>
                      <div className="row">
                        <div className="col-3">Genderqueer</div>
                        <div className="col-1">:</div>
                        <div className="col-7">{record.dir_employ_others ?? "0"}</div>
                      </div>
                      <div className="row">
                        <div className="col-3">SC/ST Employees Count</div>
                        <div className="col-1">:</div>
                        <div className="col-7">{record.dir_employ_sc_st ?? "0"}</div>
                      </div>
                      <div className="row">
                        <div className="col-3">PWD Employees Count</div>
                        <div className="col-1">:</div>
                        <div className="col-7">{record.dir_employ_pwd ?? "0"}</div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            {/* Achievements & Certifications */}
            <div className="row mt-3">
              <div className="col-12">
                <b>Achievements & Certifications</b>
              </div>
            </div>
            <div className="row">
              <div className="col-3"> Achievements of Companies</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.achievements ?? ""}</div>
            </div>
            {props.basicData?.certification && (
              <div className="row">
                <div className="col-3"> Certifications</div>
                <div className="col-1">:</div>
                {props.basicData?.certification && (
                  <div className="col-7">
                    {props.basicData?.certification != "Other"
                      ? props.basicData?.certification
                      : props.basicData?.otherCertification}
                  </div>
                )}
              </div>
            )}
            {/* Documents */}
            <div className="row mt-3">
              <div className="col-12">
                <b>Documents</b>
              </div>
            </div>
            {/* <div className="row">
            <div className="col-3">Document Uploaded</div>
            <div className="col-1">:</div>
            <div className="col-7 ">{props.basicData?.file_name}</div>
          </div> */}
            {props.update === true &&
              typeof props?.basicData?.upload_proposal === "string" ? (
              <div className="row">
                <div className="col-3 field-titles">Brochure / Leaflets</div>
                <div className="col-1 hideonMobile">:</div>
                <div className="col-7">
                  <a
                    onClick={() => {
                      window.open(
                        `${result}${props?.basicData?.upload_proposal}`,
                        "_blank"
                      );
                    }}
                    className="detailFile"
                  >
                    View
                  </a>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-3 field-titles">Document Uploaded</div>
                <div className="col-1 hideonMobile">:</div>
                <div className="col-7">{props.basicData?.file_name}</div>
              </div>
            )}
          </div>
          <div className="d-flex pt-3">
            <div>
              <center>
                <CommonForm
                  fieldType="checkbox"
                  value={agreeDeclaration1}
                  required
                  checked={agreeDeclaration1}
                  onChange={(e) => handleCheckChangeDeclaration1(e)}
                  label=""
                  {...props}
                />
              </center>
            </div>
            <div className="mt-1">
              I hereby, declare that the entries made by me in the form are
              complete and true to the best of my knowledge and based on records
            </div>
          </div>
          <div className="d-flex pt-3">
            <div>
              <center>
                <CommonForm
                  fieldType="checkbox"
                  value={agreeDeclaration2}
                  required
                  checked={agreeDeclaration2}
                  onChange={(e) => handleCheckChangeDeclaration2(e)}
                  label=""
                  {...props}
                />
              </center>
            </div>
            <div className="mt-1">
              I hereby agree to use the company's name & logo in the promotional
              activities of Kerala spacepark
            </div>
          </div>

          <div className="footer-buttons">
            <div
              className="secondary-btn"
              onClick={(e) => {
                props.action(2);
              }}
            >
              GO BACK
            </div>
            {props.update ? (
              <div
                className="primary-btn"
                onClick={(e) => {
                  props.action(3);
                }}
              >
                UPDATE
              </div>
            ) : (
              <div
                className="primary-btn"
                // onClick={(e) => {
                //   props.action(3);
                // }}
                onClick={handleCheckDeclaration}
              >
                REGISTER
              </div>
            )}
          </div>
        </div>
        {snackOpen && (
          <Snackbar
            message={snackMessage}
            error={isSnackError}
            open={snackOpen}
            close={snackbarClose}
          />
        )}
      </div></div>
  );
}
